// enableSelector mode types t() only as a selector callback. Keys resolved at
// runtime (e.g. server error codes) cannot be static selectors, so this is the
// single sanctioned escape hatch back to the string-key API. `t` is `unknown`
// so callers pass their own branded t without importing i18next here.
export const translateDynamicKey = (
  t: unknown,
  key: string,
  defaultValueOrOptions?: string | Record<string, unknown>,
  options?: Record<string, unknown>,
): string =>
  (t as (k: string, d?: unknown, o?: unknown) => string)(key, defaultValueOrOptions, options);
